import { usePropertyZipCode } from '../../../../../queries/usePropertyCoreFields';
import { ZipCodeBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PropertyAddressZipCodeProps {
    propertyGuid: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressZipCode: React.FC<PropertyAddressZipCodeProps> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'Zip Code';
    const [propertyAddressZipCode, set_propertyAddressZipCode] = usePropertyZipCode(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressZipCode}
                />
            ) : (
                <ZipCodeBox
                    id='propertyAddressZipcode'
                    value={propertyAddressZipCode}
                    onChange={(value) => set_propertyAddressZipCode(value)}
                    label={label}
                    placeholder='01234'
                    required={required}
                    readOnly={readOnly}
                    width='220px'
                    validator={validator}
                />
            )}
        </>
    );
};
